export const initialState = {
    name: "",
    tel: "",
    name_vehicle: "",
    color: "",
    license_plate: "",
    data_entrada: "",
    hora_entrada: ""
}